import { render, staticRenderFns } from "./OccipitalHeadaches.vue?vue&type=template&id=5365654c&scoped=true"
import script from "./OccipitalHeadaches.vue?vue&type=script&lang=js"
export * from "./OccipitalHeadaches.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5365654c",
  null
  
)

export default component.exports